import React from "react";
import icon1 from "../../../Assets/Home/Icon1.png";
import icon2 from "../../../Assets/Home/Icon2.png";
import icon3 from "../../../Assets/Home/Icon3.png";

const cards = [
  {
    id: 1,
    bg: "#fdf0ee",
    border: "#f5cfc9",
    iconBg: "#fff",
    Icon: icon1,
    title: "Mining Services",
    description:
      "Offering comprehensive mining services tailored to meet industry needs with expertise and advanced technology.",
  },
  {
    id: 2,
    bg: "#eef0fc",
    border: "#cdd2f5",
    iconBg: "#fff",
    Icon: icon2,
    title: "Farbrication Services",
    description:
      "Providing high-quality fabrication services with precision, durability, and attention to detail for industrial and structural needs.",
  },
  {
    id: 3,
    bg: "#edf7f0",
    border: "#c2e8cc",
    iconBg: "#fff",
    Icon: icon3,
    title: "Construction Services",
    description:
      "We provide end-to-end construction solutions, ensuring strong foundations, efficient execution, and long-lasting results",
  },
];

export default function OurServices() {
  return (
    <div
      id="service"
      className="w-full py-10 sm:py-12 px-4 sm:px-8 bg-[#f5f0e8]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map(({ id, bg, border, iconBg, Icon, title, description }) => (
          <div
            key={id}
            className="flex flex-col items-center text-center rounded-2xl px-8 py-10 cursor-pointer transition-shadow duration-300 hover:shadow-lg"
            style={{
              background: bg,
              border: `1.5px solid ${border}`,
            }}
          >
            {/* Icon box */}
            <div
              className="flex items-center justify-center rounded-2xl mb-6 shadow-sm p-4"
              style={{
                width: "64px",
                height: "64px",
                background: iconBg,
                border: `1px solid ${border}`,
              }}
            >
              <img src={Icon} alt="" className="object-cover" />
            </div>

            {/* Title */}
            <h3
              className="font-extrabold text-gray-900 mb-3"
              style={{ fontSize: "clamp(16px, 1.6vw, 20px)" }}
            >
              {title}
            </h3>

            {/* Description */}
            <p className="text-gray-500 text-sm leading-relaxed">
              {description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
